import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  /**
   * Open a confirm dialog
   * @param title - Dialog title
   * @param message - Dialog message
   * @param confirmText - Text for confirm button (default: 'Yes')
   * @param cancelText - Text for cancel button (default: 'No')
   * @returns Promise<boolean> - true if confirmed, false if cancelled
   */
  openConfirmDialog(
    title: string,
    message: string,
    confirmText: string = 'Yes',
    cancelText: string = 'No',
    type: ConfirmDialogData['type'] = 'confirm'
  ): Promise<boolean> {
    const dialogData: ConfirmDialogData = {
      title,
      message,
      confirmText,
      cancelText,
      type
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '40rem',
      data: dialogData,
      disableClose: false
    });

    return dialogRef.afterClosed().toPromise().then(result => result === true);
  }

  /**
   * Open a delete confirmation dialog
   * @param itemName - Name of the item(s) to delete
   * @returns Promise<boolean> - true if confirmed, false if cancelled
   */
  openDeleteDialog(itemName: string = 'record(s)'): Promise<boolean> {
    return this.openConfirmDialog(
      'Confirm Delete',
      `Are you sure you want to delete ${itemName}?`,
      'Delete',
      'Cancel',
      'delete'
    );
  }
}
